/**
 *
 * @type {{bindAll: Function}}
 */
ACC.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchAutocomplete("search_form", "#global-search", "#search", ACC.autocompleteUrl);
    }
};

/**
 *
 * @type {{bindAll: Function}}
 */
ACC.recipe.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchAutocomplete('search_form_recipe', "#recipe-search", "#search-filter", ACC.recipe.autocompleteUrl);
    }
};

/**
 *
 * @type {{bindAll: Function}}
 */
ACC.faq.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchAutocomplete('search_form_faq', "#faq-search", "#search-filter_faq", ACC.faq.autocompleteUrl);
    }
};

/**
 *
 * @type {{bindAll: Function}}
 */
ACC.ifu.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchAutocomplete('search_form_ifu', "#ifu-search", "#search-filter_ifu", ACC.ifu.autocompleteUrl);
    }
};

/**
 *
 * @type {{bindAll: Function}}
 */
ACC.repairs.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchRepairersAutocomplete('search_form_repairs', "#repairs-search", "#search-filter_repairs",
            ACC.repairs.autocompleteUrl);
    }
};

/**
 *
 * @type {{bindAll: Function}}
 */
ACC.store.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchAutocomplete('search_form_store', "#store-search", "#search-filter_store", ACC.store.autocompleteUrl);
    }
};

/**
 *
 * @type {{bindAll: Function}}
 */
ACC.reparability.autocomplete = {
    /**
     *
     */
    bindAll: function () {
        bindSearchReparabilityAutocomplete('search_form_reparability', "#reparability-search",
            "#search-filter_reparability", ACC.reparability.autocompleteUrl);
    }
};

/**
 *
 * @param formname
 * @param globalId
 * @param id
 * @param url
 */
bindSearchAutocomplete = function (formname, globalId, id, url) {
    $(id).autocomplete({
        source: function (request, response) {
            $.getJSON(url, {
                term: $(id).val()
            }, function (data) {
                response(data);
            });
        },
        minLength: 2,
        open: function (event, ui) {
            $(".ui-menu").css("z-index", 10000);
        },
        close: function (event, ui) {
            $(".ui-menu").css("z-index", -1);
        },
        focus: function (event, ui) {
            return false;
        },
        select: function (event, ui) {
            if (ui.item) {
                $(id).val(ui.item.value.trim());
            }
            document.forms[formname].submit();
        },
        autoFocus: false,
        delay: ACC.autocompleteDelay
    });
};

/**
 *
 * @param formname
 * @param globalId
 * @param id
 * @param url
 */
bindSearchRepairersAutocomplete = function (formname, globalId, id, url) {
    $(id).autocomplete(
        {
            source: function (request, response) {
                var termValue = $(id).val();
                if ($("form[name=" + formname + "] input[name=country]:checked").val()) {
                    termValue += "," + $("form[name=" + formname + "] input[name=country]:checked").val();
                } else if ($("form[name=" + formname + "] input[name=country]:hidden").val()) {
                    termValue += "," + $("form[name=" + formname + "] input[name=country]:hidden").val();
                }
                $.getJSON(url, {
                    term: termValue
                }, function (data) {
                    response(data);
                });
            },
            minLength: 2,
            create: function () {
                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                    return $("<li>").attr("data-value", item.address.town).append($("<a>").text(item.address.town))
                        .appendTo(ul);
                }
            },
            open: function (event, ui) {
                $(".ui-menu").css("z-index", 10000);
            },
            close: function (event, ui) {
                $(".ui-menu").css("z-index", -1);
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (event, ui) {
                if (ui.item) {
                    $(id).val(ui.item.address.town.trim());
                }
                document.forms[formname].submit();
            },
            autoFocus: false,
            delay: ACC.autocompleteDelay
        });
};

/**
 *
 * @param formname
 * @param globalId
 * @param id
 * @param url
 */
bindSearchReparabilityAutocomplete = function (formname, globalId, id, url) {
    $(id).autocomplete({
        source: function (request, response) {
            $.getJSON(url, {
                term: $(id).val()
            }, function (data) {
                response(data);
            });
        },
        minLength: 2,
        open: function (event, ui) {
            $(".ui-menu").css("z-index", 2);
        },
        close: function (event, ui) {
            $(".ui-menu").css("z-index", -1);
        },
        focus: function (event, ui) {
            return false;
        },
        select: function (event, ui) {
            if (ui.item) {
                $(id).val(ui.item.value.trim().toUpperCase());
                event.preventDefault();
            }
        },
        autoFocus: false,
        delay: ACC.autocompleteDelay
    });
};

/**
 *
 * @param ul
 * @param item
 * @returns {*|jQuery}
 */
renderPOSItem = function (ul, item) {
    return $("<li>").attr("data-value", item.address.town).append(
        $("<a>").append($("<div>").attr("class", "bloc-img")).append($("<h4>").text(item.displayName)).append(
            $("<p>").text(item.address.formattedAddress))).appendTo(ul);
};
